import { UserNotification, UserNotificationUtilService } from "@scisys-uim/uim-common";
import { RANGER_TYPE } from "assets-model";

export class RangerNotifcationUtilService implements UserNotificationUtilService {

    unableToDismissReason(notification?: UserNotification): string {
      return ""
    }
  
    canBeDismissed(notification: UserNotification): boolean {
      return false;
    }
  
    getUserMessageType(): string {
      return "RangerAction";
    }
  
    getRouteFromLinkData(notification: UserNotification): any[] {
      return RANGER_TYPE.searchRouteBase;
    }
  
    getRouteLinkQueryParams(notification: UserNotification) {
      return notification.linkData;
    }
  
  }